import ajax from '../../lib/ajax';
import {Store,Module,ActionContext} from 'vuex'
const mediamanager={
    namespaced: true,
    state:{
		progressVal:0,
    },
    actions:{
        async createMediaItems(state:any,payload:any){
			let rep = await ajax.post("/api/MediaManager/CreateMediaItems",payload.data,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					}
				}
		  	);     
			return rep.data.result;
		},
		async createMediaItem(state:any,payload:any){
			let rep = await ajax.post("/api/MediaManager/CreateMediaItem",payload.data,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					}
				}
		  	);     
			return rep.data.result;
		},
		async createPodcastItems(state:any,payload:any){
			let rep = await ajax.post("/api/MediaManager/CreatePodcastItems",payload.data);     
			return rep.data.result;
		  },
		async createVFileItems(state:any,payload:any){
	      let rep = await ajax.post("/api/MediaManager/CreateVFileItems",payload.data);     
	      return rep.data.result;
		},
		async createSliderItems(state:any,payload:any){			
			let rep = await ajax.post("/api/MediaManager/CreateSliderItems",payload.data);     
			return rep.data.result;
		  },
		  async createGalleryItems(state:any,payload:any){			
			let rep = await ajax.post("/api/MediaManager/CreateGalleryItems",payload.data);     
			return rep.data.result;
		  },
		  async croppImage(context:ActionContext<any,any>,payload:any){			
			let rep = await ajax.put("/api/MediaManager/CroppImage?Id="+payload.data.id+"&Height="+payload.data.height+"&Width="+payload.data.width+"&Top="+payload.data.top+"&Left="+payload.data.left);   
			return rep.data.result;
		  }
    }
}
export default mediamanager;